import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-user-info-viho',
  templateUrl: './user-info-viho.component.html',
  styleUrls: ['./user-info-viho.component.scss'],
  standalone:false
})
export class UserInfoVihoComponent implements OnInit {

  @Input() profile: any;
  constructor(
    private userService: UserService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    console.log('user-info')
  }

}
